// extracted by mini-css-extract-plugin
module.exports = {"details":"CostDetails_details__2SPyN","buttonsWrapper":"CostDetails_buttonsWrapper__YksN4","highlight":"CostDetails_highlight__E7u18"};